/**
 * The URLs the Share buttons hand out.
 *
 * Every share points at a backend share endpoint proxied on the SPA origin
 * (`/api/share-*`, forwarded to the App Service by Azure Static Web Apps'
 * Linked Backend — see the "Jaakko linked-backend proxy" doc). Those endpoints
 * serve Open Graph / Twitter meta HTML to social crawlers and send people on to
 * the app. Sharing a raw SPA route instead gives crawlers only index.html's
 * generic site card, because the app is client-rendered (JAA-440).
 *
 * All builders live here so the seller hero, buyer cards, building view, feed,
 * explore results, manage menus and the post-publish prompt cannot drift onto
 * different hosts again.
 */

const shareOrigin = (): string => window.location.origin;

const shareEndpoint = (path: string, params: Record<string, string>): string => {
  const query = new URLSearchParams(params).toString();
  return `${shareOrigin()}${path}?${query}`;
};

/**
 * Share URL for a single listing (seller listing, buyer listing or area
 * interest). The recipient lands on `/listing/:id/:slug`.
 */
export const listingShareUrl = (id: string): string =>
  shareEndpoint('/api/share-listing', { id });

/**
 * Share URL for a building page (no specific listing). The recipient lands on
 * the building view via `/?building-id=…`.
 */
export const buildingShareUrl = (buildingId: string): string =>
  shareEndpoint('/api/share-building', { 'building-id': buildingId });
